import { render } from "./categoriesView.vue?vue&type=template&id=e2c50d42"
import script from "./categoriesView.vue?vue&type=script&lang=js"
export * from "./categoriesView.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__